exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big-add-button[data-v-02f6e35c]{height:50px}.custom-select[data-v-02f6e35c]{line-height:32px;height:50px;border-radius:1px}", ""]);

// exports
